<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="选择医院" prop="hospitalName">
                <a-input-search
                  v-model="queryParam.hospitalName"
                  placeholder="请选择医院"
                  enter-button="选择"
                  @search="handleSelectHospital"
                  :readonly="true"
                  allow-clear
                />
                <!-- 医院选择弹窗 -->
                <table-select-modal
                  :visible.sync="hospitalSelectVisible"
                  title="选择医院"
                  :width="1000"
                  :api-method="pageHospital"
                  :columns="hospitalColumns"
                  search-label="医院名称"
                  search-key="hospitalName"
                  search-placeholder="请输入医院名称"
                  :data-path="'data.records'"
                  :total-path="'data.total'"
                  @ok="handleHospitalSelected"
                  @cancel="handleHospitalCancel"
                >
                </table-select-modal>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="省份" prop="provinceId">
                <a-select
                  v-model="queryParam.provinceId"
                  placeholder="请选择省份"
                  allow-clear
                  @change="handleProvinceChange"
                >
                  <a-select-option v-for="item in provinceList" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="城市" prop="cityId">
                <a-select
                  v-model="queryParam.cityId"
                  placeholder="请先选择省份"
                  allow-clear
                  :disabled="!queryParam.provinceId"
                >
                  <a-select-option v-for="item in cityList" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="科室名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入科室名称" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="是否百强科室" prop="isTop100">-->
<!--                  <a-select v-model="queryParam.isTop100" placeholder="请选择" allow-clear>-->
<!--                    <a-select-option value="1">是</a-select-option>-->
<!--                    <a-select-option value="0">否</a-select-option>-->
<!--                  </a-select>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作栏 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['hospital:depart:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['hospital:depart:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['hospital:depart:remove']">
          <a-icon type="delete" />删除
        </a-button>

        <a-button type="primary" @click="handleImport" v-hasPermi="['hospital:depart:import']">
          <a-icon type="upload" />导入
        </a-button>
        <!-- 同步华歧系数按钮：新增选中数量提示 -->
        <a-button type="primary" @click="handleSyncScore" v-hasPermi="['hospital:depart:syncScore']">
          <a-icon type="sync" />同步华歧系数
          <span v-if="selectedRowKeys.length > 0" class="selected-count">({{ selectedRowKeys.length }}条)</span>
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <!-- 导入弹窗 -->
      <a-modal
        title="导入"
        :visible="openUpload"
        :maskClosable="false"
        :confirm-loading="uploading"
        @cancel="importExcelHandleCancel"
        @ok="importExcelHandleChange"
      >
        <a-spin tip="上传中..." :spinning="uploading">
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :file-list="fileList"
            :multiple="false"
            :remove="handleRemove"
            :before-upload="beforeUpload"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">请将文件拖拽到此处上传❥(^_-)</p>
            <p class="ant-upload-hint">支持单个上传，也可以点击后选择文件上传</p>
          </a-upload-dragger>
          <a @click="importTemplate">下载模板</a>
        </a-spin>
      </a-modal>

      <!-- 加减分弹窗 -->
      <a-modal
        title="调整推荐分值"
        :visible="scoreModalVisible"
        :maskClosable="false"
        :confirm-loading="scoreLoading"
        @cancel="handleScoreModalCancel"
        @ok="handleScoreModalOk"
        width="400px"
      >
        <a-form :form="scoreForm" layout="vertical">
          <a-form-item label="科室名称">
            <span>{{ currentDepart?.name || '' }}</span>
          </a-form-item>
          <a-form-item label="当前分值">
            <span>{{ currentDepart?.score || 0 }}</span>
          </a-form-item>
          <a-form-item
            label="调整分值"
            :validateStatus="scoreValidateStatus"
            :help="scoreValidateHelp"
          >
            <a-input-number
              v-model="changeScore"
              :min="-3000"
              :max="3000"
              :step="1"
              placeholder="请输入调整分值"
              style="width: 100%"
              @change="handleScoreInputChange"
            />
          </a-form-item>
          <a-form-item label="调整后分值">
            <span :style="{ color: (currentDepart?.score || 0) + (changeScore || 0) < 0 ? 'red' : 'inherit' }">
              {{ (currentDepart?.score || 0) + (changeScore || 0) }}
            </span>
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 百强科室名次设置弹窗 -->
      <a-modal
        title="设置全国百强科室名次"
        :visible="top100ModalVisible"
        :maskClosable="false"
        :confirm-loading="top100Loading"
        @cancel="handleTop100ModalCancel"
        @ok="handleTop100ModalOk"
        width="400px"
      >
        <a-form :form="top100Form" layout="vertical">
          <a-form-item label="科室名称">
            <span>{{ currentTop100Depart?.name || '' }}</span>
          </a-form-item>
          <a-form-item
            label="百强名次"
            :validateStatus="rankValidateStatus"
            :help="rankValidateHelp"
            required
          >
            <a-input-number
              v-model="top100Rank"
              :min="1"
              :max="100"
              :step="1"
              placeholder="请输入1-100之间的名次"
              style="width: 100%"
              @change="handleRankInputChange"
            />
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 同步华歧系数确认弹窗 -->
      <a-modal
        title="同步华歧系数"
        :visible="syncScoreModalVisible"
        :maskClosable="false"
        :confirm-loading="syncScoreLoading"
        @cancel="handleSyncScoreCancel"
        @ok="handleSyncScoreConfirm"
        width="400px"
      >
        <div style="padding: 20px 0; line-height: 1.6;">
          <p v-if="selectedRowKeys.length > 0">
            确认要同步选中的 {{ selectedRowKeys.length }} 个科室的华歧系数吗？
          </p>
          <p v-else>
            确认要同步所有科室的华歧系数吗？
          </p>
          <p style="color: #faad14; margin-top: 8px;">
            <a-icon type="exclamation-circle" />
            <span v-if="selectedRowKeys.length > 0">
              此操作将从外部数据源同步选中医科的最新华歧系数，覆盖现有数据（注：未选择数据将同步全部数据）
            </span>
            <span v-else>
              此操作将从外部数据源同步所有科室的最新华歧系数，覆盖现有数据（注：未选择数据将同步全部数据）
            </span>
          </p>
        </div>
      </a-modal>

      <!-- 新增：科室华歧系数详情抽屉 -->
      <a-drawer
        title="华歧系数详情"
        placement="right"
        :width="600"
        :visible="scoreDetailVisible"
        :closable="true"
        @close="handleScoreDetailClose"
        destroyOnClose="true"
      >
        <div v-if="currentScoreDetail" class="score-detail-container">
          <a-descriptions :column="2" bordered size="middle">
            <!-- 展示指定的8个科室华歧系数字段 -->
            <a-descriptions-item label="科室介绍分值">
              {{ formatDecimal(currentScoreDetail.departContent) }}
            </a-descriptions-item>
            <a-descriptions-item label="科室图片分值">
              {{ formatDecimal(currentScoreDetail.departLogo) }}
            </a-descriptions-item>
            <a-descriptions-item label="科室医生注册分值">
              {{ formatDecimal(currentScoreDetail.doctorDepartRegister) }}
            </a-descriptions-item>
            <a-descriptions-item label="三级医院科室注册分值">
              {{ formatDecimal(currentScoreDetail.departLevelThree) }}
            </a-descriptions-item>
            <a-descriptions-item label="二级医院科室注册分值">
              {{ formatDecimal(currentScoreDetail.departLevelTwo) }}
            </a-descriptions-item>
            <a-descriptions-item label="一级医院科室注册分值">
              {{ formatDecimal(currentScoreDetail.departLevelOne) }}
            </a-descriptions-item>
            <a-descriptions-item label="全国百强科室分值">
              {{ formatDecimal(currentScoreDetail.topOneHundred) }}
            </a-descriptions-item>
            <a-descriptions-item label="科室基础分">
              {{ formatDecimal(currentScoreDetail.departBasic) }}
            </a-descriptions-item>
            <a-descriptions-item label="特色加减分">
              {{ formatDecimal(currentScoreDetail.addScore) }}
            </a-descriptions-item>
            <a-descriptions-item label="国内名医数量分值">
              {{ formatDecimal(currentScoreDetail.nationalFamousDoctorCount) }}
            </a-descriptions-item>
            <a-descriptions-item label="省内名医数量分值">
              {{ formatDecimal(currentScoreDetail.provincialFamousDoctorCount) }}
            </a-descriptions-item>

            <!-- 总分展示（自动计算） -->
            <a-descriptions-item label="华歧系数总分" :span="2">
              <span style="font-size: 16px; font-weight: bold; color: #1890ff;">
                {{ calculateTotalScore() }}
              </span>
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div v-else class="empty-tip">
          <a-empty description="暂无华歧系数数据" />
        </div>
      </a-drawer>

      <!-- 数据展示（操作列新增华歧系数详情按钮） -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1650 }"
      >
        <span slot="level" slot-scope="text, record">
          <dict-tag :options="dict.type['depart_level']" :value="record.level"/>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="logo" slot-scope="text, record">
          <img v-viewer v-for="item in record.logo.split(',')" :src="processImageUrl(item)" style="height: 50px;height: 50px"/>
        </span>
        <!-- 百强科室开关列 -->
        <span slot="isTop100" slot-scope="text, record">
          <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmHandleIsTop100(record)"
            @cancel="cancelHandleIsTop100(record)"
          >
            <span slot="title">确认{{ record.isTop100 === 1 ? '取消' : '设置' }}{{ record.name }}为全国百强科室吗?</span>
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="record.isTop100 === 1"
              v-hasPermi="['hospital:depart:top100']"
            />
          </a-popconfirm>
        </span>
        <!-- 百强名次展示列 -->
        <span slot="top100Rank" slot-scope="text, record">
          {{ record.isTop100 === 1 ? (record.top100Rank || '未设置') : '非百强' }}
        </span>
        <!-- 获得荣誉展示列 -->
        <span slot="honor" slot-scope="text, record">
          <a-tag v-if="record.isTop100 === 1" color="gold">全国百强科室</a-tag>
          <a-tag v-for="(honor, index) in getCustomHonors(record.honor)" :key="index" color="blue">
            {{ honor }}
          </a-tag>
          <span v-if="!record.isTop100 && !getCustomHonors(record.honor).length">-</span>
        </span>
        <!-- 荣誉证书展示列 -->
        <span slot="certificate" slot-scope="text, record">
          <a v-if="record.certificate" @click="viewCertificates(record)">
            <a-icon type="picture" /> 查看
          </a>
          <span v-else>-</span>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['hospital:depart:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['hospital:depart:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['hospital:depart:remove']">
            <a-icon type="delete" />删除
          </a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" href="#">
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['hospital:depart:score']">
                <a @click="handleScoreAdjust(record)">
                  <a-icon type="calculator" />加减分
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['hospital:depart:top100']">
                <a @click="handleSetTop100Rank(record)" :disabled="!record.isTop100">
                  <a-icon type="trophy" />设置全国百强名次
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['hospital:depart:scoreDetail']">
                <a @click="handleScoreDetail(record)">
                  <a-icon type="file-text" />华歧系数详情
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 荣誉证书预览modal -->
    <a-modal
      v-model="certificatePreviewVisible"
      title="荣誉证书预览"
      :footer="null"
      :width="800"
      centered
    >
      <div style="text-align: center;">
        <img
          :src="certificateImages[currentPreviewIndex]"
          style="max-width: 100%; max-height: 600px;"
          alt="荣誉证书"
        />
        <div v-if="certificateImages.length > 1" style="margin-top: 16px;">
          <a-button @click="prevImage" :disabled="currentPreviewIndex === 0">
            上一张
          </a-button>
          <span style="margin: 0 16px;">
            {{ currentPreviewIndex + 1 }} / {{ certificateImages.length }}
          </span>
          <a-button @click="nextImage" :disabled="currentPreviewIndex === certificateImages.length - 1">
            下一张
          </a-button>
        </div>
      </div>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import {
  pageDepart, listDepart, delDepart, importDepart, adjustDepartScore, changeDepartTop100Status,
  syncDepartScore, getDepartScoreDetail
} from '@/api/hospital/depart'
import { pageHospital } from '@/api/hospital/hospital'
import CreateForm from './modules/CreateForm'
import TableSelectModal from '@/components/TableSelectModal'
import { tableMixin } from '@/store/table-mixin'
import { processImageUrl } from '@/utils/util'
import { getProvinceList, getCityListByProvinceId } from '@/api/system/area'
import moment from "moment";

export default {
  name: 'HospitalDepart',
  components: {
    CreateForm,
    TableSelectModal
  },
  mixins: [tableMixin],
  dicts: ['depart_level'],
  data () {
    return {
      hospitalSelectVisible: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      fileList: [],
      single: true,
      uploading:false,
      openUpload: false,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 省份城市相关
      provinceList: [],
      cityList: [],
      queryParam: {
        hospitalId: null,
        hospitalName: null,
        parentName: null,
        name: null,
        level: null,
        pid: null,
        isTop100: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null,
        pageNum: 1,
        pageSize: 10
      },
      // 加减分弹窗相关
      scoreModalVisible: false,
      scoreLoading: false,
      scoreForm: this.$form.createForm(this),
      currentDepart: null,
      changeScore: 0,
      scoreValidateStatus: 'success',
      scoreValidateHelp: '正数为加分，负数为减分，0为不调整',
      // 百强科室相关
      top100ModalVisible: false,
      top100Loading: false,
      top100Form: this.$form.createForm(this),
      currentTop100Depart: null,
      top100Rank: 0,
      rankValidateStatus: 'success',
      rankValidateHelp: '请输入1-100之间的名次',
      // 同步华歧系数相关
      syncScoreModalVisible: false,
      syncScoreLoading: false,
      // 新增：华歧系数详情相关
      scoreDetailVisible: false,
      currentScoreDetail: null,
      // 新增：荣誉证书预览相关
      certificatePreviewVisible: false,
      certificateImages: [],
      currentPreviewIndex: 0,
      columns: [
        {
          title: '科室名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '科室照片',
        //   dataIndex: 'logo',
        //   width: 120,
        //   ellipsis: true,
        //   align: 'center',
        //   scopedSlots: { customRender: 'logo' }
        // },
        {
          title: '所属医院',
          dataIndex: 'hospitalName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '平台科室',
          dataIndex: 'departName',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '获得荣誉',
        //   dataIndex: 'honor',
        //   width: 150,
        //   scopedSlots: { customRender: 'honor' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '荣誉证书',
        //   dataIndex: 'certificate',
        //   width: 100,
        //   scopedSlots: { customRender: 'certificate' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '华歧系数',
          dataIndex: 'score',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否百强科室',
          dataIndex: 'isTop100',
          width: 120,
          scopedSlots: { customRender: 'isTop100' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '百强名次',
          dataIndex: 'top100Rank',
          width: 100,
          scopedSlots: { customRender: 'top100Rank' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160,
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
    this.loadProvinceList()
  },
  computed: {
    // 动态生成医院表格列
    hospitalColumns() {
      return [
        {
          title: '医院名称',
          dataIndex: 'hospitalName',
          ellipsis: true,
          width: 200
        },
        {
          title: '地区',
          dataIndex: 'areaName',
          width: 100
        },
        {
          title: '医院等级',
          dataIndex: 'level',
          width: 60
        },
        {
          title: '医院性质',
          dataIndex: 'nature',
          width: 60
        },
        {
          title: '医院类型',
          dataIndex: 'type',
          width: 60
        }
      ]
    }
  },
  watch: {
    'queryParam.provinceId': {
      handler(newVal) {
        if (newVal) {
          this.loadCityList(newVal)
        } else {
          this.cityList = []
          this.queryParam.cityId = null
        }
      }
    }
  },
  methods: {
    pageHospital,
    processImageUrl,

    // 加载省份列表
    loadProvinceList() {
      getProvinceList().then(res => {
        console.log('省份列表响应:', res)
        if (res.code === '20001' && res.data) {
          this.provinceList = res.data.map(item => ({
            id: item.areaId,
            name: item.areaName
          }))
          console.log('省份列表数据:', this.provinceList)
        } else {
          console.error('省份列表加载失败:', res)
        }
      }).catch(err => {
        console.error('省份列表请求异常:', err)
      })
    },

    // 加载城市列表
    loadCityList(provinceId) {
      getCityListByProvinceId(provinceId).then(res => {
        console.log('城市列表响应:', res)
        if (res.code === '20001' && res.data) {
          this.cityList = res.data.map(item => ({
            id: item.areaId,
            name: item.areaName
          }))
          console.log('城市列表数据:', this.cityList)
        } else {
          console.error('城市列表加载失败:', res)
          this.cityList = []
        }
      }).catch(err => {
        console.error('城市列表请求异常:', err)
        this.cityList = []
      })
    },

    // 省份变更处理
    handleProvinceChange(value) {
      this.queryParam.cityId = null
      if (value) {
        this.loadCityList(value)
      } else {
        this.cityList = []
      }
    },

    // 城市变更处理
    handleCityChange(value) {
      // 城市变更逻辑
    },

    // 打开医院选择弹窗
    handleSelectHospital () {
      this.hospitalSelectVisible = true
    },
    // 医院选择确定
    handleHospitalSelected (hospital) {
      this.queryParam.hospitalId = hospital.id
      this.queryParam.hospitalName = hospital.hospitalName
      this.hospitalSelectVisible = false
    },
    // 医院选择取消
    handleHospitalCancel () {
      this.hospitalSelectVisible = false
    },
    // 新增：格式化小数显示（空值显示0，保留2位小数）
    formatDecimal(value) {
      if (value === null || value === undefined) {
        return '0.00'
      }
      return Number(value).toFixed(2)
    },

    // 新增：计算科室华歧系数总分
    calculateTotalScore() {
      if (!this.currentScoreDetail) return '0.00'

      const {
        departContent, departLogo, doctorDepartRegister,
        departLevelThree, departLevelTwo, departLevelOne,
        topOneHundred, departBasic, addScore,
        nationalFamousDoctorCount, provincialFamousDoctorCount
      } = this.currentScoreDetail

      // 累加所有分值字段
      const total = [
        departContent, departLogo, doctorDepartRegister,
        departLevelThree, departLevelTwo, departLevelOne,
        topOneHundred, departBasic, addScore,
        nationalFamousDoctorCount, provincialFamousDoctorCount
      ].reduce((sum, val) => sum + (Number(val) || 0), 0)

      return total.toFixed(2)
    },

    beforeUpload(file) {
      this.fileList = [file]
      return false
    },
    importTemplate() {
      this.download(
        "hospital/depart/importTemplate",
        {},
        `depart_${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
      );
    },
    importExcelHandleChange() {
      this.uploading = true
      const {fileList} = this
      const formData = new FormData()
      formData.append('file', fileList[0])
      importDepart(formData)
        .then((response) => {
          if (response.success) {
            this.fileList = []
            this.$message.success(response.message)
            this.openUpload = false
            this.$emit('ok', response.data)
            this.getList()
          } else {
            this.$message.error(response.message)
            return
          }
        })
        .finally(() => {
          this.uploading = false
        })
    },
    handleImport() {
      this.title = "导入";
      this.openUpload = true;
    },
    handleRemove() {
      this.fileList = []
      this.uploading = false
    },
    importExcelHandleCancel(e) {
      this.openUpload = false
      this.fileList = []
      this.$emit('ok')
    },
    getList () {
      this.loading = true
      pageDepart(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        hospitalId: undefined,
        hospitalName: undefined,
        parentName: undefined,
        name: undefined,
        level: undefined,
        pid: undefined,
        isTop100: undefined,
        provinceId: undefined,
        provinceName: undefined,
        cityId: undefined,
        cityName: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.cityList = []
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delDepart(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功', 3)
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('hospital/depart/export', {
            ...that.queryParam
          }, `医院科室_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },

    // 加减分相关方法
    handleScoreAdjust(record) {
      this.changeScore = 0
      this.scoreValidateStatus = 'success'
      this.scoreValidateHelp = '正数为加分，负数为减分，0为不调整'
      this.currentDepart = { ...record }
      this.scoreModalVisible = true
    },
    handleScoreModalCancel() {
      this.scoreModalVisible = false
      this.currentDepart = null
      this.scoreValidateStatus = 'success'
      this.scoreValidateHelp = '正数为加分，负数为减分，0为不调整'
    },
    handleScoreInputChange() {
      this.validateScore()
    },
    validateScore() {
      const currentScore = this.currentDepart?.score || 0
      const adjustScore = this.changeScore || 0
      const finalScore = currentScore + adjustScore

      if (finalScore < 0) {
        this.scoreValidateStatus = 'error'
        this.scoreValidateHelp = `减分值不能超过当前总分(${currentScore})，最多可减${currentScore}分`
        return false
      } else if (adjustScore === 0) {
        this.scoreValidateStatus = 'warning'
        this.scoreValidateHelp = '调整分值不能为0，请输入有效的调整分值'
        return false
      } else {
        this.scoreValidateStatus = 'success'
        this.scoreValidateHelp = '正数为加分，负数为减分，0为不调整'
        return true
      }
    },
    handleScoreModalOk() {
      const isValid = this.validateScore()

      if (!isValid) {
        if (this.changeScore === 0) {
          this.$message.warning('调整分值不能为0，请输入有效的调整分值')
        } else if ((this.currentDepart?.score || 0) + (this.changeScore || 0) < 0) {
          this.$message.error(`减分值不能超过当前总分(${this.currentDepart?.score || 0})，最多可减${this.currentDepart?.score || 0}分`)
        }
        return
      }

      this.scoreLoading = true

      adjustDepartScore(this.currentDepart.id, this.changeScore)
        .then((res) => {
          if (res.success) {
            this.$message.success('分值调整成功')
            this.scoreModalVisible = false
            this.getList()
            this.changeScore = 0
          } else {
            this.$message.error(`分值调整失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.$message.error('分值调整异常，请稍后重试')
        })
        .finally(() => {
          this.scoreLoading = false
        })
    },

    // 百强科室相关方法
    confirmHandleIsTop100(record) {
      const oldStatus = record.isTop100
      const newStatus = record.isTop100 === 1 ? 0 : 1
      const text = newStatus === 1 ? '设置' : '取消'

      changeDepartTop100Status(record.id, newStatus)
        .then((res) => {
          if (res.success) {
            record.isTop100 = newStatus
            if (newStatus === 0) {
              record.top100Rank = 0
            }
            this.$message.success(`${text}全国百强科室成功`, 3)

            if (newStatus === 1 && !record.top100Rank) {
              this.handleSetTop100Rank(record)
            }
          } else {
            record.isTop100 = oldStatus
            this.$message.error(`${text}全国百强科室失败: ${res.message}`, 3)
          }
        }).catch(() => {
        record.isTop100 = oldStatus
        this.$message.error(`${text}全国百强科室异常`, 3)
      })
    },
    cancelHandleIsTop100(record) {},
    handleSetTop100Rank(record) {
      this.top100Rank = record.top100Rank || 1
      this.rankValidateStatus = 'success'
      this.rankValidateHelp = '请输入1-100之间的名次'
      this.currentTop100Depart = { ...record }
      this.top100ModalVisible = true
    },
    handleTop100ModalCancel() {
      this.top100ModalVisible = false
      this.currentTop100Depart = null
      this.top100Rank = 0
      this.rankValidateStatus = 'success'
      this.rankValidateHelp = '请输入1-100之间的名次'
    },
    handleRankInputChange() {
      this.validateRank()
    },
    validateRank() {
      if (!this.top100Rank || this.top100Rank < 1 || this.top100Rank > 100) {
        this.rankValidateStatus = 'error'
        this.rankValidateHelp = '请输入1-100之间的有效名次'
        return false
      } else {
        this.rankValidateStatus = 'success'
        this.rankValidateHelp = '请输入1-100之间的名次'
        return true
      }
    },
    handleTop100ModalOk() {
      const isValid = this.validateRank()

      if (!isValid) {
        this.$message.error('请输入1-100之间的有效名次')
        return
      }

      this.top100Loading = true

      changeDepartTop100Status(this.currentTop100Depart.id, 1, this.top100Rank)
        .then((res) => {
          if (res.success) {
            this.$message.success('全国百强名次设置成功')
            this.top100ModalVisible = false
            this.getList()
            this.top100Rank = 0
          } else {
            this.$message.error(`全国百强名次设置失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.$message.error('全国百强名次设置异常，请稍后重试')
        })
        .finally(() => {
          this.top100Loading = false
        })
    },

    // 同步华歧系数相关方法
    handleSyncScore() {
      this.syncScoreModalVisible = true
    },
    handleSyncScoreCancel() {
      this.syncScoreModalVisible = false
      this.syncScoreLoading = false
    },
    handleSyncScoreConfirm() {
      this.syncScoreLoading = true

      let syncParams = []
      if (this.selectedRowKeys.length > 0) {
        syncParams = this.selectedRowKeys.map(id => ({ id: id }))
      }

      syncDepartScore(syncParams)
        .then((res) => {
          if (res.success) {
            if (this.selectedRowKeys.length > 0) {
              this.$message.success(`已成功同步选中的 ${this.selectedRowKeys.length} 个科室华歧系数`)
            } else {
              this.$message.success('已成功同步所有科室华歧系数')
            }
            this.syncScoreModalVisible = false
            this.getList()
          } else {
            this.$message.error(`科室华歧系数同步失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.$message.error('科室华歧系数同步异常，请稍后重试')
        })
        .finally(() => {
          this.syncScoreLoading = false
        })
    },

    // ========== 新增：科室华歧系数详情相关方法 ==========
    /**
     * 打开科室华歧系数详情抽屉
     */
    handleScoreDetail(record) {
      this.scoreDetailVisible = true
      // 调用接口获取科室华歧系数详情
      getDepartScoreDetail(record.id)
        .then((res) => {
          if (res.success) {
            this.currentScoreDetail = res.data
          } else {
            this.currentScoreDetail = null
            this.$message.error(`获取华歧系数详情失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.currentScoreDetail = null
          this.$message.error('获取华歧系数详情异常，请稍后重试')
        })
    },

    /**
     * 关闭科室华歧系数详情抽屉
     */
    handleScoreDetailClose() {
      this.scoreDetailVisible = false
      this.currentScoreDetail = null
    },

    // ========== 新增：荣誉证书相关方法 ==========
    // 获取自定义荣誉列表
    getCustomHonors(honorStr) {
      if (!honorStr) return []
      // 从逗号分隔的字符串中解析荣誉
      const honorList = honorStr.split(',').map(item => item.trim())
      // 过滤掉"全国百强科室"
      return honorList.filter(item => item && item !== '全国百强科室')
    },
    // 查看荣誉证书
    viewCertificates(record) {
      if (record.certificate) {
        this.certificateImages = record.certificate.split(',').map(url => processImageUrl(url))
        this.currentPreviewIndex = 0
        this.certificatePreviewVisible = true
      } else {
        this.$message.warning('暂无荣誉证书')
      }
    },
    // 上一张图片
    prevImage() {
      if (this.currentPreviewIndex > 0) {
        this.currentPreviewIndex--
      }
    },
    // 下一张图片
    nextImage() {
      if (this.currentPreviewIndex < this.certificateImages.length - 1) {
        this.currentPreviewIndex++
      }
    }
  }
}
</script>

<style scoped>
/* 原有样式 */
.ant-table-cell .ant-divider {
  margin: 0 4px;
}
.selected-count {
  display: inline-block;
  background: #1890ff;
  color: white;
  font-size: 12px;
  padding: 0 4px;
  border-radius: 8px;
  margin-left: 4px;
}

/* 华歧系数详情样式 */
.score-detail-container {
  padding: 16px 0;
}

.empty-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}

.ant-descriptions-item-content {
  word-break: break-all;
}
</style>